// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sidebar__banner[data-v-35b66bd0]{margin:40px 0}", ""]);
// Exports
module.exports = exports;
